import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box} from '@material-ui/core'
import {Button, TextField } from '@material-ui/core';
import { t } from 'i18next';
import { isInteger, isNumber } from '../../../api/validators';


class NewNetworkDialog_ extends React.Component{

    constructor(props){
        super(props)

        const {settings} = this.props
        //console.log('NewNetworkDialog_ settings')
        //console.log(settings)

        this.state = {
            settings: {
                
                ID: settings ? settings.ID : '',
                Name: '', //settings ? settings.Name : '',
                CmdPort: settings ? settings.CmdPort : '',
                VideoPort: settings ? settings.VideoPort : '',
                VoIpPort: settings ? settings.VoIpPort: '',
                
            },
            errors:{
        
                ID: false,
                Name: false, 
                CmdPort: false,
                VideoPort: false,
                VoIpPort: false,

            },
            //permissionsDialogOpen: false,
            changed: false,
            //permissionsType: user.ID && user.Permissions>=0 ? 0 : -1
        }

        this.handleInput = this.handleInput.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleComplete = this.handleComplete.bind(this)
    }

    handleSave(){
        if(this.checkForm()){
            let settings = {...this.props.settings, ...this.state.settings}
            this.props.onAction({type: 'NEW_NETWORK_CREATE', settings: settings, callback: this.handleComplete})
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    handleComplete(){
        this.props.onAction({type: 'NEW_NETWORK_DIALOG_CLOSE'})
        return true
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'NEW_NETWORK_DIALOG_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'NEW_NETWORK_DIALOG_CLOSE'})
        }
    }

    handleInput(event){
        let changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value
        const settings = {...this.state.settings, [event.target.name]: val}
        
        let err = this.validate(event.target.name, val)
        const errors = {errors: {...this.state.errors, [event.target.name]: err}}

        this.setState({settings: settings, ...changed,  ...errors})
    }

    validate(name, value){
        const {t} = this.props

        let error = false

        //console.log('validate '+ name + ' = '+value)

        switch(name){
            case 'Name':
                if(!value) return this.label(name) + ': ' + t('ValueIsEmpty')
                break

            case 'CmdPort':
            case 'VideoPort':
            case 'VoIpPort':
                if(!value) return  this.label(name) + ': ' + t('ValueIsEmpty')
                if(!isInteger(value)) return  this.label(name) + ': ' + t('IsNotInteger')
                break
        }

        return error
    }

    label(name){
        let {t} = this.props
        switch(name){
            case 'CmdPort': return t('CommandPort')
            case 'VoIpPort': return t('AudioPort')

            default: return t(name)
        }
    }

    checkForm(){
        console.log('checkform')
        console.log(this.state.dispatcher)
        let check = true
        let errors = {...this.state.errors}
        for(var i in errors){
            let v = null
            let error = false
            v = this.state.settings[i]
   
            error = this.validate(i, v)
            errors[i] = error
            if(error) {
                console.error({field: i, value: v, error: error})
                check = false
            }
        }
        this.setState({errors: errors})
        return check
    }


    render(){

        const {t} = this.props

        //console.log('this.state.settings');
        //console.log(this.state.settings);

        return (
        
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{t('NewNetwork')}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>

            <Box textAlign="center">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.settings.Name}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="CmdPort"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.CmdPort?this.state.errors.CmdPort:t('CommandPort')}
                    autoComplete="new-password"
                    error={this.state.errors.CmdPort!==false}
                    value={this.state.settings.CmdPort}
                    onChange={this.handleInput}
                />
            </Box>        

            <Box textAlign="center">
                <TextField name="VoIpPort"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.VoIpPort?this.state.errors.VoIpPort:t('AudioPort')}
                    autoComplete="new-password"
                    error={this.state.errors.VoIpPort!==false}
                    value={this.state.settings.VoIpPort}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="center">
                <TextField name="VideoPort"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.VideoPort?this.state.errors.VideoPort:t('VideoPort')}
                    autoComplete="new-password"
                    error={this.state.errors.VideoPort!==false}
                    value={this.state.settings.VideoPort}
                    onChange={this.handleInput}
                />
            </Box>

        
            </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>        
        
        
        )

    }


}

export const NewNetworkDialog = withTranslation()(NewNetworkDialog_);